import { GridSpacing } from '@material-ui/core/Grid'

type GridDefaultSpacingMap = { [key in string]: GridSpacing }

export const GRID_DEFAULT_SPACING: GridDefaultSpacingMap = {
  COLUMN: 24,
  ROW: 16,
}
